import { trigger, transition, style, query, animateChild, group, animate } from '@angular/animations';

export function fadeCondition(from, to) {
  return from != null && to != null;
}

/**
 * ルーティングのアニメーション定義
 */
export const routeAnimations = trigger('routeAnimations', [
  // 画面切り替え(フェードイン、フェードアウト)
  transition(fadeCondition, [
    style({ position: 'relative', height: '100vh', overflow: 'hidden', margin: 0 }),
    query(':enter, :leave', [
      style({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100vh',
        display: 'block',
        'background-color': '#efefef'
      })
    ]),
    query(':enter', [
      style({ opacity: 0 })
    ]),
    query(':leave', [
      style({ opacity: 1 })
    ]),
    query(':leave', animateChild()),
    group([
      query(':leave', [ animate('300ms ease-out', style({ opacity: 0 })) ]),
      query(':enter', [ animate('300ms ease-out', style({ opacity: 1 })) ])
    ]),
    query(':enter', animateChild())
  ])
]);
